import type { Me } from '@pa/api/me'
import { useRouter } from '@tanstack/react-router'
import { ChevronRight } from 'lucide-react'
import { useSession } from '../auth/AuthProvider'
import { activeMemberships } from '../me/me'
import { AuthCard } from './AuthCard'

/** Frontend §5.3 row 4: the last clinic picked, remembered in this browser. */
export const LAST_CLINIC_KEY = 'pa.lastClinicId'

export function rememberedClinicId(): string | null {
  try {
    return localStorage.getItem(LAST_CLINIC_KEY)
  } catch {
    return null
  }
}

/** The clinic picker (Frontend §5.2): shown when a user belongs to several clinics (D-23). */
export function ClinicPicker({ siteName, me }: { siteName: string; me: Me }) {
  const router = useRouter()
  const session = useSession()
  const last = rememberedClinicId()
  const pick = (clinicId: string) => {
    try {
      localStorage.setItem(LAST_CLINIC_KEY, clinicId)
    } catch {
      // Private mode: nothing is remembered.
    }
    void router.navigate({ href: `/clinics/${clinicId}/appointments` })
  }
  return (
    <AuthCard siteName={siteName}>
      <div>
        <h1>Choose a clinic</h1>
        <p className="muted">You belong to more than one clinic.</p>
      </div>
      <div className="picker-list">
        {activeMemberships(me).map((m) => (
          <button
            key={m.clinic.id}
            type="button"
            className="picker-item"
            onClick={() => {
              pick(m.clinic.id)
            }}
          >
            <span>
              <b>{m.clinic.name}</b>
              <span className="cell-sub">
                {m.role === 'admin' ? 'Admin' : 'User'}
                {m.clinic.id === last ? ' · Last used' : ''}
              </span>
            </span>
            <ChevronRight aria-hidden />
          </button>
        ))}
      </div>
      <button type="button" className="btn btn-ghost btn-block" onClick={() => void session.signOut()}>
        Sign out
      </button>
    </AuthCard>
  )
}
